//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';
import { featureFlagClient } from '@trello/feature-flag-client';

const syncQueue = new Map();

//@ts-ignore
class PluginData extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'PluginData';
  }

  urlRoot() {
    // @ts-ignore
    return `/1/${this.get('scope')}/${this.get('idModel')}/pluginData`;
  }

  /**
   * Override the update method for this model, and ensure we always wait for the
   * in-flight persist to complete, before starting another. The reason for this
   * is due to the pluginData design, and the API used by power-ups to interact
   * with it, clobbering data is possible. To prevent this, we use a
   * `If-Unmodified-Since` header, to prevent updates using a stale data as a
   * basis.
   * This header relies on the `model.dateLastUpdated` value matching what the
   * server knows. If we don't wait for the in-flight set to complete, our
   * `dateLastUpdated` will not match the soon-to-be-updated value, and thus,
   * server will reject our request.
   */
  // @ts-ignore
  update(key, value, opts, next) {
    const id = this.get('id');
    if (syncQueue.has(id)) {
      // Queue the most current sync to happen once the in-progress one is
      // finished
      let newNext = next;
      const previouslyQueuedUpdate = syncQueue.get(id);
      if (previouslyQueuedUpdate) {
        newNext = function () {
          previouslyQueuedUpdate.next?.(...arguments);
          next?.(...arguments);
        };
      }
      syncQueue.set(id, {
        fx: () => {
          this.update(key, value, opts, newNext);
        },
        next,
      });
      // Immediately update the model, to avoid losing any information if we
      // drop PUT requests, due to the sync queue
      super.update(key, value, {
        skipPersist: true,
      });
      return;
    }
    // We have an in-flight sync, but no sync queued up
    syncQueue.set(id, null);
    const runNextSync = () => {
      const queuedSync = syncQueue.get(id);
      syncQueue.delete(id);
      queuedSync?.fx();
    };

    return super.update(key, value, opts, (err: Error) => {
      if (!err) {
        // If the update has succeeded, we _know_ this model was just updated,
        // we update the `dateLastUpdated` field right away, so that we can make
        // another update right away, without needing to wait for the field to
        // be updated via a socket update. IDEALLY this field would be updated
        // by the response to the PUT returning the new model, but in this case,
        // the model is not returned for PUT requests.
        this.set({ dateLastUpdated: Date.now() });
      }
      runNextSync();
      next?.(...arguments);
    });
  }

  shouldSendIfUnmodified() {
    const idPlugin = this.get('idPlugin');
    const allowedPlugins: string[] = featureFlagClient.get(
      'workflowers.prevent-stale-plugindata-writes',
      [],
    );
    return allowedPlugins.includes(idPlugin);
  }
}
PluginData.initClass();

export { PluginData };
